// Simple Redux-like state management using Context API
export interface StatsState {
  totalStudents: number;
  yearsOfExperience: number;
  totalInstructors: number;
  classesPerWeek: number;
  loading: boolean;
  error: string | null;
}

export const initialStatsState: StatsState = {
  totalStudents: 0,
  yearsOfExperience: 14,
  totalInstructors: 0,
  classesPerWeek: 0,
  loading: true,
  error: null,
};

export type StatsAction =
  | { type: 'SET_LOADING'; payload: boolean }
  | { type: 'SET_STATS'; payload: Omit<StatsState, 'loading' | 'error'> }
  | { type: 'SET_ERROR'; payload: string }
  | { type: 'RESET' };

export const statsReducer = (state: StatsState, action: StatsAction): StatsState => {
  switch (action.type) {
    case 'SET_LOADING':
      return { ...state, loading: action.payload };
    case 'SET_STATS':
      return { ...state, ...action.payload, loading: false, error: null };
    case 'SET_ERROR':
      return { ...state, error: action.payload, loading: false };
    case 'RESET':
      return initialStatsState;
    default:
      return state;
  }
};
